import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { routerReducer as router } from 'react-router-redux'

import app from './app'
import form from './form'

export default combineReducers({
  app,
  form,
  form: formReducer,
  router,
})